import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Plus, Truck, Package, Barcode, Warning, Check, ClipboardText, FileText,
  Eye, X, CaretRight, ListChecks, Lock, Prohibit, Pause, Trash, DownloadSimple,
  Camera, ImageSquare, Printer, Lightning, Gauge, CalendarCheck,
} from '@phosphor-icons/react';

import { SumItem, SummaryBar, STATUS_META, NEXT_STATUS } from '../_shared';

export const DocsAuditTab = ({ detail, isManager, docs, audit, onOpenDocs, onOpenAudit }) => (
  <div className="mt-4 space-y-3" data-testid="docs-tab">
    <div className="grid grid-cols-2 gap-4">
      <div className="border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-bold uppercase tracking-widest text-foreground flex items-center gap-2">
            <FileText size={14} weight="bold" /> Documents ({(detail.documents || []).length})
          </h3>
          <Button size="sm" variant="outline" onClick={onOpenDocs} data-testid="manage-docs-btn" className="rounded-none">
            Manage
          </Button>
        </div>
        <ul className="space-y-1 text-sm">
          {(detail.documents || []).slice(0, 5).map(d => (
            <li key={d.doc_id} className="flex items-center gap-2 text-foreground">
              <FileText size={12} /> <span className="font-mono text-xs">{d.doc_type}</span> — {d.filename}
            </li>
          ))}
          {(detail.documents || []).length === 0 && <li className="text-muted-foreground text-xs">No documents attached.</li>}
        </ul>
      </div>
      <div className="border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-bold uppercase tracking-widest text-foreground flex items-center gap-2">
            <Eye size={14} weight="bold" /> Audit Trail ({(detail.audit || []).length})
          </h3>
          <Button size="sm" variant="outline" onClick={onOpenAudit} data-testid="view-audit-btn" className="rounded-none">View</Button>
        </div>
        <ul className="space-y-1 text-xs text-foreground">
          {(detail.audit || []).slice(-5).reverse().map((a, i) => (
            <li key={i} className="flex items-center gap-2">
              <span className="font-mono font-bold uppercase text-[10px]">{a.action}</span>
              <span className="text-muted-foreground font-mono text-[10px]">{new Date(a.timestamp).toLocaleTimeString()}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

